import { useEffect, useRef, useState } from 'react';
import { $k18n } from '@/common/i18n';
import { logger } from '@/common/log';
import { useGetStoreCartItem, useQuery } from '../hooks/useGetStoreCartItem';
import { useShopInfoStore } from '../store/shopInfoStore';
import { setTimeoutRandom } from '@/common/utils/random';

function fixDate(num) {
    return num < 10 ? '0' + num : num;
}

export function useCountDown(pruductItem) {
    const [flashSaleCountDownStr, setFlashSaleCountDownStr] = useState('');
    const { loadShopData: loadSelectHaltScreen } = useGetStoreCartItem();
    const flashSaleTimeout = useRef(-1);
    const setStoreCartItem = useShopInfoStore((state) => state.setStoreCartItem);
    const flashSaleInfo = pruductItem?.flashSaleInfo;
    const [countTimer, setCountTimer] = useState('');
    const { query } = useQuery();

    function countDown() {
        const _timeout = setTimeout(() => {
            const currentTimeout = flashSaleTimeout.current;
            const hours = Math.floor(currentTimeout / (60 * 60));
            const minutes = Math.floor((currentTimeout % (60 * 60)) / 60);
            const seconds = Math.floor(currentTimeout % 60);
            const endDate = new Date(flashSaleInfo.endTime);
            currentTimeout >= 0
                ? setFlashSaleCountDownStr(
                      hours >= 24
                          ? $k18n({
                                id: 'k_370315',
                                text: `${fixDate(endDate.getMonth() + 1)}-${fixDate(endDate.getDate())} ${fixDate(endDate.getHours())}:${fixDate(
                                    endDate.getMinutes(),
                                )}:${fixDate(endDate.getSeconds())}`,
                                params: {
                                    time: `${fixDate(endDate.getMonth() + 1)}-${fixDate(endDate.getDate())} ${fixDate(endDate.getHours())}:${fixDate(
                                        endDate.getMinutes(),
                                    )}:${fixDate(endDate.getSeconds())}`,
                                },
                            })
                          : $k18n({
                                id: 'k_370314',
                                text: `${fixDate(hours)}:${fixDate(minutes)}:${fixDate(seconds)}`,
                                params: {
                                    time: `${fixDate(hours)}:${fixDate(minutes)}:${fixDate(seconds)}`,
                                },
                            }),
                  )
                : null;
            if (currentTimeout === 0) {
                console.log('setFlashSaleCountDownStr');
                setFlashSaleCountDownStr('');
                setTimeoutRandom(loadSelectHaltScreen);
                return;
            }
            flashSaleTimeout.current = currentTimeout - 1;
            countDown();
        }, 1000);

        setCountTimer(_timeout);
    }

    useEffect(() => {
        if (countTimer) {
            clearTimeout(countTimer);
            setCountTimer('');
        }
        if (flashSaleInfo) {
            //setFlashSaleTimeout(Math.ceil((flashSaleInfo.endTime - flashSaleInfo.nowTime)/1000))
            flashSaleTimeout.current = Math.ceil((flashSaleInfo.endTime - flashSaleInfo.nowTime) / 1000);
            logger.sendShow({
                action: 'SECKILL_COUNT_DOWN',
                params: {
                    product_id: pruductItem.skuId,
                },
            });
            countDown();
        } else {
            setFlashSaleCountDownStr('');
        }
    }, [flashSaleInfo]);

    console.log('flashSaleCountDownStr ', flashSaleCountDownStr);

    return {
        flashSaleCountDownStr,
    };
}
